import { useContext } from "react";
import { PathnameContext, PathnameContextType } from "../contexts/pathname.context";

export const usePathname = () => {
    return useContext(PathnameContext) as PathnameContextType;
};
